import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the types for the user state
interface IPurlUserState {
  contactOwnerId?: string | null;
  email?: string | null;
  pinNew?: string | null;
  contactGroup?: string | null;
  firstName?: string | null;
  advisorName?: string | null;
  phone?: string | null;
  contactOwnerRole?: string | null;
  bookkeeperPin?: string | null;
  contactOwnerZUID?: string | null;
  creatorId?: string | null;
  solarStudyInvite?: boolean | null;
  cpaEmail?: string | null;
  advisorPin?: string | null;
  advisorPhone?: string | null;
  advisorEmail?: string | null;
  contactOwnerEmail?: string | null;
  cpaPin?: string | null;
  solarStudyId?: string | null;
  contactOwnerPhone?: string | null;
  modifiedTime?: string | null;
  bookkeeperName?: string | null;
  bookkeeperEmail?: string | null;
  cpaPhone?: string | null;
  pin?: string | null;
  contactOwner?: string | null;
  lastName?: string | null;
  uniqueId?: string | null;
  crmContactId?: string | null;
  rowId?: string | null;
  cpaName?: string | null;
  entityName?: string | null;
  New_Sign_In_Enabled?: string | null;
  annualIncome?: string | null;
  stateOfResidence?: string | null;
}

// Define the initial state with all fields set to undefined (or null where needed)
const initialState: IPurlUserState = {
  contactOwnerId: null,
  email: null,
  pinNew: null,
  contactGroup: null,
  firstName: null,
  advisorName: null,
  phone: null,
  contactOwnerRole: null,
  bookkeeperPin: null,
  contactOwnerZUID: null,
  creatorId: null,
  solarStudyInvite: null,
  cpaEmail: null,
  advisorPin: null,
  advisorPhone: null,
  advisorEmail: null,
  contactOwnerEmail: null,
  cpaPin: null,
  solarStudyId: null,
  contactOwnerPhone: null,
  modifiedTime: null,
  bookkeeperName: null,
  bookkeeperEmail: null,
  cpaPhone: null,
  pin: null,
  contactOwner: null,
  lastName: null,
  uniqueId: null,
  crmContactId: null,
  rowId: null,
  cpaName: null,
  entityName: null,
  New_Sign_In_Enabled: null,
  annualIncome: null,
  stateOfResidence: null,
};

const purlUserSlice = createSlice({
  name: "purlUser",
  initialState,
  reducers: {
    setPurlUser: (state, action: PayloadAction<IPurlUserState>) => {
      return { ...state, ...action.payload };
    },
    updatePurlUser: (state, action: PayloadAction<Partial<IPurlUserState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetPurlUser: () => initialState,
  },
});

export const { setPurlUser, updatePurlUser, resetPurlUser } =
  purlUserSlice.actions;
export default purlUserSlice.reducer;
